import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Translation } from 'react-i18next';

import { connect } from 'react-redux';
import { patchProductLink } from 'redux/catalog/actions';

import { Checkbox } from 'semantic-ui-react';

import './ProductPublishedCheckbox.css';


class ProductPublishedCheckbox extends Component {
  static propTypes = {
    patchProductLink: PropTypes.func.isRequired,
    productId: PropTypes.number.isRequired,
    idPublished: PropTypes.bool,
  };

  static defaultProps = {
    idPublished: null,
  };

  state = {
    firstChange:  null,
    currentIsPublished: null,
  };

  componentDidMount() {
    this.setState({ currentIsPublished: this.props.isPublished });
  }

  componentDidUpdate(prevProps, prevState) {
    const { productId, patchProductLink } = this.props;
    const { currentIsPublished, firstChange } = this.state;

    if (
      !!firstChange &&
      prevState.currentIsPublished !== this.state.currentIsPublished
    ) {
      patchProductLink(productId, { is_published: currentIsPublished });
    }
  }

  onCheckboxChange = () => {
    this.setState({
      firstChange: true,
      currentIsPublished: !this.state.currentIsPublished,
    });
  }

  render() {
    const { isPublished } = this.props;
    const { firstChange, currentIsPublished } = this.state;

    return (
      <Translation>
        {(t) => (
          <div className="product-published-checkbox__component">
            <div className="switcher-wrapper">
              <span>{t("OFF")}</span>
              <Checkbox
                toggle
                checked={firstChange ? currentIsPublished : isPublished}
                onChange={this.onCheckboxChange}
              />
              <span>{t("ON")}</span>
            </div>
          </div>
        )}
      </Translation>
    );
  }
}

const mapStateToProps = state => (
  {
    patchProductLinkError: state.catalogReducer.patchProductLinkError,
  }
);

export default connect(
  mapStateToProps,
  {
    patchProductLink,
  },
)(ProductPublishedCheckbox);
